import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// --- Admin role impersonation ----------------------------------------------
// AuthContext stores the admin's chosen "view-as" role in sessionStorage.
// Attach it on every outgoing request so backend endpoints honour the
// impersonated role for authorisation (e.g. supervisor-only vessel start/stop)
// without the admin having to log out and back in.
const VIEW_AS_KEY = "ttv.viewAsRole";
api.interceptors.request.use((config) => {
    try {
        const r = sessionStorage.getItem(VIEW_AS_KEY);
        if (r) {
            config.headers = config.headers || {};
            config.headers["X-Act-As"] = r;
        }
    } catch { /* storage not available */ }
    return config;
});

export function formatApiError(err) {
    const d = err?.response?.data?.detail;
    if (!d) return err?.message || "Something went wrong";
    if (typeof d === "string") return d;
    if (Array.isArray(d))
        return d
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .join(" ");
    return String(d);
}
